const urlBase64ToUint8Array = (base64String) => {
	const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
	const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
	const rawData = window.atob(base64);
	const outputArray = new Uint8Array(rawData.length);

	for (let i = 0; i < rawData.length; i += 1) {
		outputArray[i] = rawData.charCodeAt(i);
	}

	return outputArray;
};

export const registerServiceWorker = async () => {
	if (!('serviceWorker' in navigator)) return null;

	try {
		return await navigator.serviceWorker.register('/service-worker.js', { scope: '/' });
	} catch (error) {
		console.error('Service worker registration failed:', error);
		return null;
	}
};

export const subscribeToPushNotifications = async ({
	vapidPublicKeyEndpoint,
	createSubscriptionEndpoint,
	csrfToken
}) => {
	if (!('Notification' in window) || !('PushManager' in window)) return null;
	if (Notification.permission === 'denied') return null;

	const registration = await registerServiceWorker();
	if (!registration) return null;

	const permission =
		Notification.permission === 'granted' ? 'granted' : await Notification.requestPermission();
	if (permission !== 'granted') return null;

	const keyResponse = await fetch(vapidPublicKeyEndpoint);
	if (!keyResponse.ok) return null;

	const keyData = await keyResponse.json();
	if (!keyData.success || !keyData.data.public_key) return null;

	let subscription = await registration.pushManager.getSubscription();
	if (!subscription) {
		subscription = await registration.pushManager.subscribe({
			userVisibleOnly: true,
			applicationServerKey: urlBase64ToUint8Array(keyData.data.public_key)
		});
	}

	const subscriptionJson = subscription.toJSON();
	const response = await fetch(createSubscriptionEndpoint, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-CSRF-Token': csrfToken
		},
		body: JSON.stringify({
			subscription: {
				endpoint: subscriptionJson.endpoint,
				p256dh: subscriptionJson.keys.p256dh,
				auth: subscriptionJson.keys.auth
			}
		})
	});

	if (!response.ok) {
		console.error('Failed to save push subscription');
		return null;
	}

	return subscription;
};

export const initializePwa = async ({ endpoints, csrfToken, authenticated }) => {
	await registerServiceWorker();

	if (!authenticated || !endpoints) return;

	await subscribeToPushNotifications({
		vapidPublicKeyEndpoint: endpoints.get_push_vapid_public_key_endpoint,
		createSubscriptionEndpoint: endpoints.create_push_subscription_endpoint,
		csrfToken
	});
};
